// src/App.tsx
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignInPage from './Component/Auth/signin';
import OTPVerification from './Component/Auth/otp_verify';
import Layout from './Component/Layout/Layout';

import { AuthProvider } from './context/auth/AuthContext';
import { ChatProvider } from './context/ChatContext/chatContext';
import ProtectedRoute from '../src/Component/Auth/ProtectedRoute';
import './Component/chat/component/chat.css';
import 'simplebar-react/dist/simplebar.min.css';

// Mobile Restriction Component
const MobileRestriction = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5',
      textAlign: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px 30px',
        maxWidth: '400px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <svg 
          style={{ width: '80px', height: '80px', marginBottom: '20px', color: '#ef4444' }}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
          />
        </svg>
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '12px'
        }}>
          Desktop or Larger Screen Required
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          lineHeight: '1.5',
          marginBottom: '20px'
        }}>
          This application requires a screen size of at least 1024px. Please access it from a desktop computer or larger device for the best experience.
        </p>
        
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          fontSize: '14px',
          color: '#9ca3af',
          flexWrap: 'wrap'
        }}>
          <span>📱 Mobile/Tablet: Not Supported</span>
          <span>💻 Desktop (1024px+): Supported</span>
        </div>
      </div>
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (isMobile) {
    return <MobileRestriction />;
  }

  return (
    <AuthProvider>
      <ChatProvider>
       
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/signin" element={<SignInPage />} />
              <Route path="/signin/verify-otp" element={<OTPVerification />} />
              
              {/* Protected routes with Layout (Sidebar) */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              />
              
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
      
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;

//</CustomizerContextProvider>